import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//import { Link } from 'react-router-dom';
import { useAppSelector } from '../../../hooks';
import { selectHastaTransmitter } from '../../../reducers/hastaTransmittersSlice';
/*
const rollershadeSetup = (id: number) => {
    const link = `/config/hasta-transmitter/${id}/setup`;

    return (
        <div>
          <Link to={link}>Installation
          </Link>
        </div>
    );
}
*/
export const ConfigHastaTransmitterRow = (props) => {
    const transmitter = useAppSelector(selectHastaTransmitter(props.id));
    if (!transmitter) {
        return null;
    }
    const active = true;
    const label_classes = 'inactive label ' + (active ? ' hidden' : '');
    return (_jsxs("div", { className: "config-transmitter-row", children: [_jsxs("div", { children: [transmitter.title, _jsx("span", { className: label_classes, children: "Inaktiv" })] }), _jsx("div", {}), _jsx("div", { className: "pull-right", children: _jsx("button", { className: "edit lw small", onClick: () => props.editHandler(transmitter.id), children: "\u00A0Redigera\u00A0" }) })] }));
};
